import { AiAnswerFeedbackPage } from '@atlassian/ai-answer-feedback-page';
import { ScreenName } from '@atlassian/help-center-common-component/constants';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';
import { anonymousScreenLayout, PORTAL_ROUTE_PREFIX } from '../common/constants';

const route = {
    name: ScreenName.AI_ANSWER,
    path: `${PORTAL_ROUTE_PREFIX}/:requestKey/aianswer`,
    exact: true,
    component: AiAnswerFeedbackPage,
};

const screenName = ScreenName.AI_ANSWER;

export const aiAnswerRoute = createRouteWithLayout(route, screenName, anonymousScreenLayout);
